module.exports = __webpack_public_path__ + "img/at.3cb91c54.svg";